import { Client } from "@microsoft/microsoft-graph-client"
import React, { useEffect, useState } from "react";
import NavBar from "./NavBar";
import Box from "@mui/material/Box";
import Moment from "react-moment";
import { makeStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import { Config } from "../Config";

const useStyles = makeStyles({
  serverInfo: { color: "#545454", textAlign: "left", margin: "5px 0 0 20px" },
  welcomeText: {
    color: "#fff",
    fontWeight: "bold !important",
    fontSize: "32px !important",
    textAlign: "left",
    paddingLeft: "24px",
  },
  welcomeBox: {
    backgroundColor: Config.environment.color,
    marginTop: "3px",
    height: "64px",
    "& h1": {
      lineHeight: "64px",
    },
  },
});

function Header({ graphClient }: { graphClient: Client | undefined }) {
  const classes = useStyles();
  const [serverName, setServerName] = useState<string>();
  const now = new Date();

  useEffect(() => {
    fetch("/podname")
      .then((res) => res.text())
      .then(
        (result) => {
          setServerName(result);
        },
        (error) => {
          console.error(error);
        }
      );
  }, []);

  return (
    <>
      <NavBar graphClient={graphClient} />
      <Box className={classes.serverInfo}>
        Server name: {serverName}{" "}
        <Moment format="DD/MM/YYYY HH:mm:ss">{now}</Moment>
      </Box>
      <Box className={classes.welcomeBox}>
        <Typography className={classes.welcomeText} variant="h1">
          {Config.environment.name}
        </Typography>
      </Box>
    </>
  );
}

export default Header;
